<script setup lang="ts">
  import { useChatSession } from '@healthpilot/acars'

  defineProps<{
    suggestions: string[]
  }>()

  const { sendMessage } = useChatSession()
  const session = SessionStore.use()
  const { track } = Analytics.use()

  const onSelect = (suggestion: string) => {
    sendMessage(suggestion)
    session.chatSuggestionsUsed.push(suggestion)
    track('ChatFaqSelected', {
      faqText: suggestion
    })
  }
</script>

<template>
  <div
    v-for="suggestion in suggestions"
    @click="() => onSelect(suggestion)"
    class="w-full max-w-[20rem] cursor-pointer rounded-button bg-primary-600 px-6 py-3 font-semibold leading-normal text-white shadow-menu transition-colors duration-300 hover:bg-primary-800"
  >
    {{ suggestion }}
  </div>
</template>
